
export class ProgramResourcesNav {
  public static item = {
    title: 'program.tab.resources',
    url: 'resources',
    icon: '<img src="./assets/icons/line-icons/nav/grey/application.svg" width="23px" height="23px">',
    testId: 'prog-nav-resources',
  };
}
